import * as React from 'react';
import './style.css';

import Row from './Row';

import App from 'src/state/App';

export function decorateRating(
  targetRating: number,
  previousRating: number,
  tolerance: number = 1,
): string | null {
  const diff = (
    Math.round(App.scaleRating(targetRating)) -
    Math.round(App.scaleRating(previousRating))
  );

  if (Math.abs(diff) < tolerance) {
    return null;
  }

  return (diff > 0 ? '+' : '-') + Math.abs(diff);
}

const Leaderboard: React.SFC<{
  players: {
    name: string,
    rating: number,
    decoration: string | null,
  }[],
}> = ({ players }) => {
  let rank = 0;
  let rating = null;

  const ratingsEqual = (a: number | null, b: number) => {
    if (a === null) {
      return false;
    }

    const aa = Math.round(App.scaleRating(a));
    const bb = Math.round(App.scaleRating(b));

    return aa === bb;
  };

  const rankedPlayers = [];

  for (let i = 0; i < players.length; i++) {
    const player = players[i];

    if (!ratingsEqual(rating, player.rating)) {
      rank = i + 1;
    }

    rankedPlayers.push({ ...player, rank, i });
  }

  const maxRating = 0.001 + (players
    .map(p => p.rating)
    .reduce((a, b) => Math.max(a, b), -Infinity)
  );

  const minRating = -0.001 + (players
    .map(p => p.rating)
    .reduce((a, b) => Math.min(a, b), Infinity)
  );

  const RelRating = (rating: number) => (
    (rating - minRating) / (maxRating - minRating)
  );

  const n = players.length;

  const height = (n === 0 ? '' : `${2 * n}em`);

  rankedPlayers.sort((a, b) => a.name < b.name ? -1 : a.name > b.name ? 1 : 0);

  return (
    <div className="leaderboard" style={{ height }}>
      {
        n === 0 ?
        (<div className="placeholder">No players have been added yet.</div>) :
        rankedPlayers.map(({ rank, name, decoration, rating, i }) => (
          <div
            className="row-positioner"
            key={name}
            style={{
              top: `${2 * i}em`,
              zIndex: n - i,
            }}
          >
            <Row
              rank={rank}
              name={name}
              rating={rating}
              relRating={RelRating(rating)}
              decoration={decoration}
            />
          </div>
        ))
      }
    </div>
  );
};

export default Leaderboard;



// WEBPACK FOOTER //
// ./src/ui/Leaderboard/index.tsx